import DataGridT from './DataGridT'

const Transacciones = () => {
  return (
    <div>
      <DataGridT />
    </div>
  )
}

export default Transacciones